import { createLocaleService } from './LocaleService.impl';

export const myLocaleService = createLocaleService();
